// Login Page Component
// This is the page users see when they need to log in
// It includes a form with username and password fields

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

function Login() {
    // State to store form inputs
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Get login function from Auth context
    const { login } = useAuth();
    
    // Navigation hook to redirect after login
    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent page reload
        
        // Clear any previous errors
        setError('');
        
        // Basic validation
        if (!username || !password) {
            setError('Please enter both username and password');
            return;
        }

        // Set loading state
        setIsLoading(true);

        // Try to log in
        const result = await login(username, password);

        // Stop loading
        setIsLoading(false);

        if (result.success) {
            // Login successful - redirect to dashboard
            navigate('/dashboard');
        } else {
            // Login failed - show error message
            setError(result.message);
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1>Flash | Utilities</h1>
                    <p>Sign in to your account</p>
                </div>

                {/* Show error message if login fails */}
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    {/* Username input field */}
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your username"
                            disabled={isLoading}
                            autoComplete="username"
                        />
                    </div>

                    {/* Password input field */}
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            disabled={isLoading}
                            autoComplete="current-password"
                        />
                    </div>

                    {/* Submit button */}
                    <button 
                        type="submit" 
                        className="login-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Login;